<form class="flexer padding no-top-padding">
  <div class="form-title">
    <div class="form-title-text">Materiaal & afmetingen</div>
  </div>

  <div class="d-flex upper-space">
    <div>
      <div class="form-sub-title">Type folie</div>
      <mat-form-field appearance="outline">
        <mat-select
          name="materialType"
          matInput
          placeholder="Maak een keuze"
          [(ngModel)]="inputProduct.temporaryMaterial"
          (ngModelChange)="materialTypeUpdate($event)"
          [disabled]="disabled"
          required
        >
          <mat-option
            *ngFor="let option of temporaryMaterialOptions"
            [value]="option.value"
          >
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <windowsticker-material-picker
      class="form-field"
      *ngIf="allProductSizes != null"
      [inputMaterialAware]="inputProduct"
      [sizesEndpoint]="'/window_sticker_sizes'"
      [allProductSizes]="allProductSizes"
      [updateEmitter]="outPutWindowSticker"
      [productMaterialChanged]="productMaterialChanged"
      [temporaryMaterialChanged]="temporaryMaterialChanged"
      [client]="client"
      [disabled]="disabled"
    ></windowsticker-material-picker>
  </div>

  <div *ngIf="init">
    <mat-card
      class="mat-elevation-z0 under-space"
      *ngFor="
        let standardStickerPart of inputProduct.standardStickerParts;
        let index = index
      "
    >
      <div class="d-flex justify-content-between">
        <div class="form-sub-title">Sticker #{{ index + 1 }}</div>
        <div
          *ngIf="!disabled"
          (click)="deleteStandardStickerPart(index)"
          class="close"
        >
          <mat-icon svgIcon="close"></mat-icon>
        </div>
      </div>

      <size-picker
        [inputProduct]="inputProduct"
        [inputStandardStickerPart]="standardStickerPart"
        [index]="index"
        [productSizes]="allProductSizes"
        [productMaterialChanged]="productMaterialChanged"
        [client]="client"
        [disabled]="disabled"
        (updateProduct)="outPutWindowSticker.emit()"
      >
      </size-picker>

      <mat-form-field class="wide" appearance="outline">
        <textarea
          [ngClass]="client ? 'client-textarea' : ''"
          class="textarea"
          matInput
          placeholder="Extra info"
          [(ngModel)]="standardStickerPart.layoutDescription"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="disabled"
          (ngModelChange)="layoutDescriptionChanged()"
          cdkTextareaAutosize
        ></textarea>
      </mat-form-field>
    </mat-card>

    <div>
      <button
        class="button under-space"
        (click)="addStandardStickerPart()"
        type="button"
        mat-button
      >
        Extra sticker toevoegen
      </button>
    </div>
  </div>

  <design-picker
    *ngIf="!client && !fromOldSystem"
    [inputProduct]="inputProduct"
    [inputProject]="inputProject"
    [disabled]="disabled"
    (updateProduct)="outPutWindowSticker.emit()"
  >
  </design-picker>
</form>
<internal-project-form
  *ngIf="!client && !fromOldSystem"
  [inputProject]="inputProject"
  [inputProduct]="inputProduct"
  [involvedCompanies]="involvedCompanies"
  [pmsColorAdded]="pmsColorAdded"
  (updateProduct)="outPutWindowSticker.emit()"
></internal-project-form>
